import * as React from "react";
const SvgFiRrSkating = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skating_svg__a)">
      <path
        fill="#062147"
        d="M9.707 16.06a1 1 0 0 1 0 1.414L5.685 21.5l.2.2a1 1 0 0 0 1.415.014 1 1 0 1 1 1.4 1.43 3.007 3.007 0 0 1-4.243-.044l-2.8-2.857a1 1 0 1 1 1.427-1.4l1.2 1.225 4.01-4.008a1 1 0 0 1 1.413 0M20 21a3 3 0 0 1-3 3h-4a1 1 0 0 1 0-2h2v-3.726l-4.94-4.693A3.35 3.35 0 0 1 10 8.784L12.781 6h-7.78a1 1 0 0 1 0-2h8.143c1.172 0 2.307.412 3.206 1.163l.671.56a3 3 0 0 1 .1 4.337l-3.83 3.83 3.4 3.23a1 1 0 0 1 .31.724V22a1 1 0 0 0 1-1 1 1 0 0 1 2 0m-8.983-9.83a1.34 1.34 0 0 0 .42.96l.4.383 3.865-3.865a1 1 0 0 0-.016-1.432l-.618-.516c-.029-.024-.063-.04-.092-.064L11.411 10.2a1.35 1.35 0 0 0-.394.97M19.5-.046a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skating_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkating;
